import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import AppConfig from '../../appConfig';

/**
 * @param {object} pram0
 * @param {import('../../').LayerLibraryItemMetadataClassSvg} pram0.svg
 * @param {string} pram0.type
 * @param {React.CSSProperties} pram0.style
 * @param {React.CSSProperties} pram0.markerStyle
 */
const ClassesItemImage = ({ svg, type, style, iconSize, markerStyle }) => {
    let icon;
    if (svg) {
        icon = (
            <img
                src={`${AppConfig.constants.assetsBaseURL}/svg/${svg.icon}.svg`}
                width={iconSize}
                height={iconSize}
                alt="Legend item icon"
            />
        );
    } else {
        icon = <i className={`socex-icon-${type}`} style={markerStyle} />;
    }

    return (
        <div
            className={classNames('layer-library-classes__item-icon', {
                'layer-library-classes__item-icon--svg': svg,
            })}
            style={style}
        >
            {icon}
        </div>
    );
};

ClassesItemImage.propTypes = {
    svg: PropTypes.object,
    type: PropTypes.string,
    style: PropTypes.object,
    markerStyle: PropTypes.object,
    iconSize: PropTypes.number,
};

ClassesItemImage.defaultProps = {
    svg: undefined,
    type: 'circle',
    style: {},
    iconSize: 24,
    markerStyle: {}
};

export default ClassesItemImage;
